import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5acbc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "deleteRoleModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "deleteRoleModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Delete role", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  for: "name",
  class: "form-label"
}
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.loading ? "Loading" : `Please enter the role name "${_ctx.role?.name}" `), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "name",
              placeholder: "Role Name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger ms-2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.role?.name != _ctx.name || _ctx.submitted
          }, _toDisplayString(_ctx.submitted ? "Deleting" : "Delete"), 9, _hoisted_11)
        ])
      ])
    ])
  ]))
}